// shared/hooks/useDeleteEntry.js
import { deleteEntry } from '@mysimpledb/shared/data/deleteEntry';
import { useNotify } from '@mysimpledb/shared/context/NotificationContext';

export function useDeleteEntry() {
  const notify = useNotify();

  return async (entryId, token) => {
    try {
      const result = await deleteEntry(entryId, token);
      notify.show('Entry deleted successfully');
      return result;
    } catch (err) {
      console.error('Failed to delete entry:', err);
      notify.show('Failed to delete entry');
      throw err;
    }
  };
}
